<style scoped lang="scss" type="text/scss">
    .traditional-award-container {
        .submit-buttons {
            margin-top: 1rem;
        }

        .form-content-container {
            overflow: auto;
        }
    }
</style>

<template>
    <div class="traditional-award-container global-relative">
        <loading-placeholder :loading="loading"></loading-placeholder>

        <section class="form-content-container" :style="{'max-height': visualAreaHeight}">
            <block-divider>一等奖（ 多选 ）</block-divider>
            <competition-candidate-player-selector v-model="first"></competition-candidate-player-selector>

            <block-divider>二等奖（ 多选 ）</block-divider>
            <competition-candidate-player-selector v-model="second"></competition-candidate-player-selector>

            <block-divider>三等奖（ 多选 ）</block-divider>
            <competition-candidate-player-selector v-model="third"></competition-candidate-player-selector>
        </section>

        <div class="submit-buttons">
            <el-button type="primary" plain @click="update()" :loading="requesting">保存</el-button>
            <el-button @click="reset()">重置</el-button>
        </div>
    </div>
</template>

<script>
    import BlockDivider from '../../../../../../components/divider/block';
    import CompetitionCandidatePlayerSelector from '../../../../../sub-components/competition-candidate-player-selector';
    import {handlePlayerAwards} from '../../../../../../utils/data-handler';
    import {PLAYER_AWARD_TYPE_VALUE_MAP} from '../../../../../../constant/player-award-type';
    import _ from 'lodash';

    export default {
        name: '',
        components: {
            BlockDivider,
            CompetitionCandidatePlayerSelector
        },
        data () {
            return {
                loading: false,
                requesting: false,
                first: [],
                second: [],
                third: []
            };
        },
        computed: {
            currentCompetitionId () {
                return this.$store.state.competition.currentCompetitionId;
            },
            visualAreaHeight () {
                return this.$store.getters['layout/adminAwardVisualAreaHeight'] + 'px';
            }
        },
        watch: {
            currentCompetitionId: {
                immediate: true,
                handler (currentCompetitionId) {
                    if (currentCompetitionId === null || currentCompetitionId === undefined) return;
                    this.loadAwards();
                }
            }
        },
        methods: {
            loadAwards () {
                this.$normalRequest('competition/loadTop32PlayerAwards', {
                    competition_id: this.currentCompetitionId
                }, false, false, this, 'loading').then(data => {
                    const awards = handlePlayerAwards(data);
                    if (awards[PLAYER_AWARD_TYPE_VALUE_MAP.FIRST] === undefined) {
                        this.first = [];
                    } else {
                        this.first = _.map(awards[PLAYER_AWARD_TYPE_VALUE_MAP.FIRST], 'player_id');
                    }
                    if (awards[PLAYER_AWARD_TYPE_VALUE_MAP.SECOND] === undefined) {
                        this.second = [];
                    } else {
                        this.second = _.map(awards[PLAYER_AWARD_TYPE_VALUE_MAP.SECOND], 'player_id');
                    }
                    if (awards[PLAYER_AWARD_TYPE_VALUE_MAP.THIRD] === undefined) {
                        this.third = [];
                    } else {
                        this.third = _.map(awards[PLAYER_AWARD_TYPE_VALUE_MAP.THIRD], 'player_id');
                    }
                });
            },
            update () {
                this.$normalRequest('competition/updateTop32PlayerAwards', {
                    competition_id: this.currentCompetitionId,
                    first: this.first,
                    second: this.second,
                    third: this.third
                }, '标准奖项更新成功', true, this, 'requesting').then(_ => {
                    this.loadAwards();
                }).catch(_ => {
                });
            },
            reset () {
                this.loadAwards();
            }
        }
    };
</script>
